import { apiFGTS } from '../http/httpClient'

export const approveTransaction = async (id: string): Promise<any> => {
  const response = await apiFGTS
    .post<any>(`/transaction/${id}/approve`)
    .catch((error) => {
      throw error.response.data
    })

  return response.data
}
